import { HomeFilterData } from "../../dto/home/home-filter-data"
import { PeriodValueResponseDto } from "../../dto/home/period-value-response"
import httpClient from "../../service/api"
import { getSession } from "../../service/session"

export interface HomeData {
  filter: HomeFilterData
  periodValuesMonth?: PeriodValueResponseDto
  periodValuesDay?: PeriodValueResponseDto
  date?:Date
  isShowMargem?:boolean
}

export const findData = async (filter: HomeFilterData) => {
  const dataMonth = await httpClient.post('/api/home/process-period-month', filter)
  const dataDay = await httpClient.post('/api/home/process-period-day', filter)
  const session = await getSession()

  return {
    filter : filter,
    periodValuesMonth: dataMonth.data,
    periodValuesDay: dataDay.data,
    date: new Date(),
    isShowMargem: session.isShowMargem
  } as HomeData
}
